<a
  panButton
  icon="history"
  color="primary"
  form="square"
  ariaLabel="Activity log"
  [routerLink]="['/home/review-management/locations', params.data.id, 'activity']"
  data-testid="review-activity-link"
></a>
